import React from 'react';
import { classNames } from '../../../../utils/common/styling.js';
import { styles } from './ModalFooter.styles.js';

var ModalFooter = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, children = _a.children;
    return (React.createElement("div", { className: classNames(styles.modalFooter, className) }, children));
};

export { ModalFooter as default };
//# sourceMappingURL=ModalFooter.js.map
